export const DEFAULT_FILE_NAME = 'filename.mp4'
export const SIZE_VIDEO = {
	MIN_WIDTH: 1280,
	MIN_HEIGHT: 720,
}
